import { useResetOrder } from '../state/order/hooks/useOrderMutation';
import { storage } from '../utils/storage';
import { KotipizzaLocalStorageKeys } from '../types';

export const useWebshopStateReset = (): {
  handleResetOrderState: () => void;
  handleResetWebshopState: () => void;
} => {
  const resetOrder = useResetOrder();
  /**
   * Reset the order state
   * This is used when the user session should be preserved.
   */
  const handleResetOrderState = (): void => {
    storage.removeItem(KotipizzaLocalStorageKeys.PICKUP_SEARCH_QUERY);
    resetOrder();
  };

  /**
   * Reset the webshop state.
   * This includes:
   * - reset the order state
   * - log out customer
   */
  const handleResetWebshopState = (): void => {
    resetOrder();
    const excludedKeys = ['kotipizza.logged_out_loyalty_member'];
    const storageKeys = storage.keys();
    storageKeys.forEach((element) => {
      if (!excludedKeys.includes(element)) storage.removeItem(element);
    });
    window.location.reload();
  };

  return { handleResetOrderState, handleResetWebshopState };
};
